import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Unit } from '../../../../settings-module/models/unit';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromBlog from '../../../reducers/blog.reducer';
import * as fromRoot from '../../../../reducers';
import { getSelectedUnit } from '../../../../reducers';
import { getBlogState, selectBlogListing } from '../../../reducers';
import {
  AddBlogListingItem,
  DeleteBlogListingItem,
  RemoveBlogListingItem,
} from '../../../actions/blog.actions';
import { BlogService } from '../../../../lib/services/blogService';
import { BlogListingModel } from '../../../models/blog-listing.model';
import {
  JobListingItem,
  LISTING_ITEM_ABOUT_JOB,
  LISTING_ITEM_ABOUT_OFFICE,
  LISTING_ITEM_FOOTER,
  LISTING_ITEM_FREE_TEXT,
  LISTING_ITEM_FREE_TEXT_IMAGE,
  LISTING_ITEM_HEADER,
  LISTING_ITEM_IMAGE,
  LISTING_ITEM_JOBS,
  LISTING_ITEM_TYPE,
  LISTING_ITEM_VIDEO,
} from '../../../../jobs-module/models/listing.model';
import { getBlogListingEntities } from '../../../reducers/blog.reducer';

@Component({
  selector: 'mj-blog-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingComponent implements OnInit, OnDestroy {
  listing: BlogListingModel;
  blogState$: Subscription;
  selectedUnit$: Observable<Unit>;

  public rearrangeState = false;

  constructor(
    public blogService: BlogService,
    private root_store: Store<fromRoot.State>,
    private store: Store<fromBlog.State>
  ) {}

  ngOnInit() {
    this.selectedUnit$ = this.root_store.select(getSelectedUnit);
    this.blogState$ = this.store
      .select(selectBlogListing)
      .subscribe((listing: BlogListingModel) => {
        if (listing) {
          this.listing = listing;
        }
      });
  }

  addItem(item: JobListingItem) {
    const newItem: any = this._getItemFromType(item.type);
    const newListingItems = [...this.listing.blog_listing_items];
    newListingItems.splice(item.position, 0, {
      ...newItem,
      free_text_image_type: item.free_text_image_type,
    });
    const newListingItemsWithNewPositions = newListingItems.map((it, index) => {
      return { ...it, position: index };
    });
    this.store.dispatch(
      new AddBlogListingItem({
        new_listing: {
          ...this.listing,
          blog_listing_items: newListingItemsWithNewPositions,
        },
        is_blog_listing_valid: this.blogService.checkValidBlogListing(
          this.listing
        ),
      })
    );
  }

  removeItem(item: JobListingItem) {
    const newListingItems = this.listing.blog_listing_items
      .filter(listingItem => listingItem.position !== item.position)
      .map((it, index) => {
        return { ...it, position: index };
      });
    this.store.dispatch(
      new RemoveBlogListingItem({
        new_listing: {
          ...this.listing,
          blog_listing_items: newListingItems,
        },
        is_blog_listing_valid: this.blogService.checkValidBlogListing(
          this.listing
        ),
      })
    );
    if (item.id) {
      this.store.dispatch(new DeleteBlogListingItem({ item: item }));
    }
  }

  updateListing(item: JobListingItem) {
    const newListingItems = [...this.listing.blog_listing_items];
    newListingItems.splice(item.position, 1, item);
    this.store.dispatch(
      new AddBlogListingItem({
        new_listing: {
          ...this.listing,
          blog_listing_items: newListingItems,
        },
        is_blog_listing_valid: this.blogService.checkValidBlogListing(
          this.listing
        ),
      })
    );
  }

  rearrangeListing(items: JobListingItem[]) {
    // its a bit hacky, we have no update action
    this.store.dispatch(
      new AddBlogListingItem({
        new_listing: { ...this.listing, blog_listing_items: items },
        is_blog_listing_valid: this.blogService.checkValidBlogListing(
          this.listing
        ),
      })
    );
  }

  presentRearrangeScreen(enabled: boolean) {
    this.rearrangeState = enabled;
  }

  ngOnDestroy() {
    if (this.blogState$) {
      this.blogState$.unsubscribe();
    }
  }
  trackByFn(index, item) {
    return index;
  }

  _getItemFromType(type: number) {
    switch (type) {
      case LISTING_ITEM_TYPE.LISTING_ITEM_HEADER:
        return LISTING_ITEM_HEADER;
      case LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB:
        return LISTING_ITEM_ABOUT_JOB;
      case LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE:
        return LISTING_ITEM_IMAGE;
      case LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO:
        return LISTING_ITEM_VIDEO;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT:
        return LISTING_ITEM_FREE_TEXT;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE:
        return LISTING_ITEM_FREE_TEXT_IMAGE;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER:
        return LISTING_ITEM_FOOTER;
      case LISTING_ITEM_TYPE.LISTING_ITEM_JOBS:
        return LISTING_ITEM_JOBS;
      case LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE:
        return LISTING_ITEM_ABOUT_OFFICE;
      default:
        return LISTING_ITEM_FREE_TEXT_IMAGE;
    }
  }
}
